import { gql } from '@apollo/client'

const registerOrUpdateVenueDevice = gql(`
  mutation registerOrUpdateVenueDevice($email: String, $deviceId: String!, $description: String, $platformType: String, $active: Boolean, $osVersion: String, $appVersion: String ){
    registerOrUpdateVenueDevice(
      email : $email
      deviceId : $deviceId
      description : $description
      platformType : $platformType
      active : $active
      osVersion : $osVersion
      appVersion: $appVersion
    ){
    error {
      message
    }
    success 
    data{
      message
    }
    }
  }`)

export default registerOrUpdateVenueDevice
